import React from 'react';
import {connect, useDispatch} from 'react-redux';
import {withTranslation} from 'react-i18next';
import classNames from 'classnames';
import './index.scss';

import {MODEL_CONTROL_TYPE} from '../../../utils/enums';

import SearchBox from '../SearchBox';
import IconButton from '../IconButton';
import SectionItemsTitleControls from '../SectionItemsTitleControls';
import {getTranslateTitle} from '../../../utils/objects-util.js';
import SectionItemSelect from '../SectionItemSelect/index.js';
import {createAction} from '../../../utils/sagaHelper.js';

const SectionItemsTitle = ({
                               t,
                               sectionModel,
                               searchValue,
                               items,
                               onOptionChange,
                               item,
                               onBack,
                               itemsCount,
                               onLayout,
  onSetDragMode,
  saveDragModeLoader,
  onSaveDragChanges,
  onUpdateSectionModelData,
  showSearchItemsAmount,
  onFilterOrdersClose,
  systemLanguage,
                               isLoading,
                               translationsLanguage,
                               models
                           }) => {
    const isMobile = window.innerWidth < 768;

    const sectionModelLabel = getTranslateTitle(sectionModel?.label);

    const handleSearch = value => {
        if (typeof onOptionChange !== 'function') return;
        onOptionChange('search', 'selected', value);
    };


    return (
        <div>
            <div className={classNames('sectionItemsTitle')}>
                <div className={classNames('leftSide')}>
                    <div className={'controls'}>
                        {sectionModel.controls
                            .filter(
                                control => (control.isShow ? control.isShow(items) : true) && control.type === MODEL_CONTROL_TYPE.back
                            )
                            .map(control => (
                                <div className={'controlItem'} key={`control-${control.type}`}>
                                    <button className={'btn backBtn'} onClick={() => onBack()}>
                                        <IconButton isIcon iconName={'smallArrow'}/>
                                        {t('basic.BACK_BUTTON')}
                                    </button>
                                </div>
                            ))}
                        {sectionModel.showNeedSave && sectionModel.showNeedSave({models, sectionModel}) && (
                            <div className={'needSave'}></div>
                        )}
                    </div>
                    {sectionModel.breadcrumbs && (
                        <div className={'breadcrumbs'}>
                            {sectionModel.breadcrumbs
                                .filter(breadcrumb => breadcrumb.isShow)
                                .map((breadcrumb, index) => {
                                    const label = breadcrumb.label || breadcrumb?.getLabel?.();
                                    return (
                                        <div className={'itemBreadcrumb'} key={`${breadcrumb.label}-${index}`}>
                                            {label && `\xa0${label} /`}
                                        </div>
                                    );
                                })}
                        </div>
                    )}
                </div>
                <div className={classNames('centerSide')}>
                    {sectionModelLabel && <span className={'sectionLabel'}>{sectionModelLabel}</span>}
                    {sectionModel.getLabel && <span className={'sectionLabel'}>{sectionModel.getLabel(item)}</span>}
                    {itemsCount > 0 && itemsCount !== undefined && !isMobile && !isLoading && (
                        <span className={classNames('amount')}>{itemsCount}</span>
                    )}
                </div>
                <div className={classNames('rightSide')}>
                    {!!sectionModel?.showFilterValueInHeader && (
                        <div>{sectionModel?.showFilterValueInHeader
                            .map(option => option.formatData(sectionModel.getFilterOptionPropValue(option.filterOptionName, 'selected')))
                            .filter(Boolean)
                            .join(' - ')
                        }</div>
                    )}
                    {sectionModel?.controlSelect && (
                        <SectionItemsTitleSelectControl sectionModel={sectionModel}
                                                        translationsLanguage={translationsLanguage}/>
                    )}
                    {!sectionModel.isDraggable && !!sectionModel?.filterOptions?.options?.search && (
                        <div className={classNames('search', {withSearch: !!sectionModel?.withSearch})}>
                            {itemsCount !== undefined && showSearchItemsAmount() && (
                                <span className={classNames('amount')}>{itemsCount || 0}</span>
                            )}
                            {sectionModel?.filterOptions?.options?.search && (
                                <SearchBox
                                    useValue={searchValue}
                                    placeholder={t('orders.SEARCH_PLACEHOLDER')}
                                    debounce={500}
                                    onChange={value => handleSearch(value)}
                                />
                            )}
                        </div>
                    )}
                    {(!sectionModel.controlSettings || sectionModel.controlSettings?.position === 'header') &&
                        <SectionItemsTitleControls
                            item={item}
                            sectionModel={sectionModel}
                            items={items}
                            onBack={onBack}
                            onSetDragMode={onSetDragMode}
                            saveDragModeLoader={saveDragModeLoader}
                            onLayout={onLayout}
                            onSaveDragChanges={onSaveDragChanges}
                            onUpdateSectionModelData={onUpdateSectionModelData}
                            onFilterOrdersClose={onFilterOrdersClose}
                            systemLanguage={systemLanguage}
                            models={models}
                        />}

                    {sectionModel.reportControl && (
                        sectionModel.reportControl()
                    )}
                </div>
            </div>

            {(sectionModel.controlSettings && sectionModel.controlSettings.position === 'subHeader') &&
                <div className={classNames('sectionItemsTitle sectionItemsTitleBlock')}>
                    <SectionItemsTitleControls
                        item={item}
                        sectionModel={sectionModel}
                        items={items}
                        onBack={onBack}
                        onSetDragMode={onSetDragMode}
                        saveDragModeLoader={saveDragModeLoader}
                        onLayout={onLayout}
                        onSaveDragChanges={onSaveDragChanges}
                        onUpdateSectionModelData={onUpdateSectionModelData}
                        onFilterOrdersClose={onFilterOrdersClose}
                        systemLanguage={systemLanguage}
                        models={models}
                    /></div>}
        </div>
    );
};

const SectionItemsTitleSelectControl = ({sectionModel, translationsLanguage}) => {
    const dispatch = useDispatch();

    const {values, action} = sectionModel?.controlSelect || {};

    const handleSetValue = value => {
        if (!value) return;
        dispatch(createAction(action, value));
    };

    return (
        <div style={{width: '95px'}}>
            <SectionItemSelect
                value={translationsLanguage}
                column={{
                    accessor: 'language',
                    values: values,
                }}
                onPropChange={value => handleSetValue(value)}
            />
        </div>
    );
};

const mapStateToProps = state => {
    return {
        isLoading: state.sectionsWrapperData.isLoading,
        models: state.sectionModel?.sectionModels,
        translationsLanguage: state.restaurant.data?.translations?.language,
    };
};

export default connect(mapStateToProps)(withTranslation()(SectionItemsTitle));
